<template>
  <div>
    <div class="p-24" v-show="!show_edit">
      <div class="flex align-items-center">
        <div class="text-strong mr-8">{{ project.name }}</div>
        <div class="btn btn-silent btn-slim" @click="show_edit = true">Change</div>
      </div>
      <div class="flex align-items-center mt-8">
        <span class="color-gray-500 pr-8">{{ project.deadline ? 'Deadline on ' + project.deadline : 'No deadline' }}</span>
        <div class="fas fa-circle" style="font-size: 5px;"></div>
        <span class="color-gray-500 pl-8">{{ project.fixed_price ? project.fixed_price : 'No fixed price' }}</span>
      </div>
    </div>
    <div class="p-24" v-show="show_edit">
      <div>
        <div class="text-strong">Project name</div>
        <div class="flex">
          <div @click="copyProjectName()" style="align-self: center; margin-right: 10px; font-size: 1.3rem; cursor: pointer;">
            <i class="fas fa-copy fa-2x"></i>
          </div>
          <v-select
            style="width: 100%;"
            v-model="project.name"
            :options="clientProjects"
            label="name"
            @blur="$v.project.$touch()"
            :taggable="true"
            ref="projectNameInput"
          ></v-select>
        </div>
      </div>
      <div class="flex mt-16">
<!--        <div class="flex-grow-1 mr-8">-->
<!--          <div class="text-strong">Client</div>-->
<!--          <div>-->
<!--            <v-select-->
<!--              v-if="clients"-->
<!--              :disabled="!clients || lock_client"-->
<!--              v-model="project.client"-->
<!--              :options="clients"-->
<!--              label="name"-->
<!--              :reduce="c => c.id"-->
<!--              @blur="$v.project.client.$touch()"-->
<!--            ></v-select>-->
<!--            <div class="text-detail mt-1" v-if="project.client && project.client.manager">Responsible manager - {{ project.client.manager.name }}</div>-->
<!--          </div>-->
<!--        </div>-->
        <div class="flex-grow-1 mr-8">
          <div class="text-strong">Services</div>
          <div>
            <v-select
              v-if="services"
              :disabled="!services"
              v-model="project.service"
              :options="services"
              label="name"
              :reduce="s => s.id"
              :class="{'invalid': validation.service_id}"
              @blur="$v.project.service.$touch()"
            ></v-select>
            <div class="text-detail mt-1" v-if="project.client && project.client.manager">Responsible manager - {{ project.client.manager.name }}</div>
          </div>
        </div>
        <div class="flex-grow-1 mr-8 ml-8">
          <div class="text-strong">Deadline</div>
          <div>
            <date-picker
              @dateSelected="project.deadline = $event"
              :dateFormat="'dd M yyyy'"
              :defaultDate="project.deadline"
              @blur="$v.project.deadline.$touch()"
            ></date-picker>
          </div>
        </div>
        <div class="flex-grow-1 ml-8">
          <div class="text-strong">Fixed price, EUR</div>
          <div>
            <input v-model="project.fixed_price" type="text" class="form-control" placeholder="Fixed price, EUR">
          </div>
        </div>
        <div class="flex-grow-1 ml-8">
          <div class="text-strong">Foreseen duration</div>
          <div>
            <input v-model="project.duration" type="text" class="form-control" :class="{'invalid': validation.duration}" placeholder="00:00">
          </div>
        </div>
      </div>

      <div class="mt-3">
        <div class="text-strong">Description</div>
        <textarea class="form-control" rows="8" v-model="project.description"></textarea>
      </div>
    </div>
  </div>
</template>
<script>
import DatePicker from "../../../../components/partials/Datepicker";

export default {
  components: {
    DatePicker,
  },
  props: {
    value: {},
    client: {},
    lock_client: {},
    validation: {},
  },
  created() {
    this.axios.get('clients?with[]=manager').then(response => {
      this.clients = response.data.data
    })
    this.axios.get('/n/services').then(response => {
      this.services = response.data.data
    })

    this.$root.$on('TaskDetailsEdit::addedFirstTask', () => {
      // this.show_edit = false
    })

    this.$root.$on('TaskDetailsEdit::removedAllTasks', () => {
      // this.show_edit = true
    })

    this.$root.$on('ProjectDetailsEdit::reset', ({client}) => {
      this.project = {
        name: null,
        client: client,
        deadline: null,
        fixed_price: null,
        duration: null,
        description: null,
        service: null,
      }
    })

    this.$root.$on('ProjectDetailsEdit::setProject', ({project}) => {
      this.setProject(project)
    })
  },
  data() {
    return {
      clients: [],
      project: {
        name: null,
        client: null,
        deadline: null,
        fixed_price: null,
        duration: null,
        description: null,
        service: null,
      },
      show_edit: true,
      clientProjects: [],
      services: null,
    }
  },
  watch: {
    'client': function (value) {
      this.project.client = value
      this.axios.get('n/projects?client_id=' + value.id).then(response => {
        this.clientProjects = _.map(response.data.data, project => project.name)
      })
    },
    'project': {
      handler(value) {
        this.$emit('input', value)
      },
      deep: true,
    }
  },
  methods: {
    setProject(project) {
      this.project.name = project.name
      this.project.client = project.client
      this.project.deadline = project.deadline ? moment(project.deadline).format('DD MMM YYYY') : null
      this.project.fixed_price = project.fixed_price
      this.project.duration = project.duration_formatted
      this.project.description = project.description
      this.project.service = project.service
    },
    copyProjectName() {
      if (!this.project) {
        return
      }
      let container = this.$refs.copyContainer
      this.$copyText(this.project.name, container).then((e) => {
        this.copied = true
        setTimeout(() => {
          this.copied = false
        }, 1000)
      }, (e) => {
        alert('Couldn\'t copy')
      })
    }
  }
}
</script>
<style lang="scss">
.invalid .dropdown-toggle, input.invalid {
  border-color: red !important;
}
</style>





// WEBPACK FOOTER //
// src/views/agenda-v2/task-pool/project-modal/project-details-edit.vue